<template>
  <div class="cr-registration">
    <div class="cr-container">
      <Form :validation-schema="schema"
            v-slot="{ errors, meta, handleSubmit }"  :initial-values="initialFormValues" :validateOnMount="false" v-bind="validateMode"
            @invalid-submit="handleInvalidSubmit"
      >
      <form class="cr-registration__wrapper cr-form" @submit.prevent="handleSubmit(onSubmit)"
            autocomplete="off">
        <div class="cr-registration__section">
          <div class="cr-registration__header">
            <div class="cr-registration__title">
              Здравствуйте, мы рады приветствовать вас
            </div>
            <div class="cr-registration__text">
              Приветственный текст
            </div>
            <div class="cr-registration__text">
              У вас уже есть аккаунт?
              <router-link class="cr-link" to="/auth/">Есть аккаунт</router-link>
            </div>
          </div>
        </div>

        <div class="cr-registration__section">
          <fieldset class="cr-form__fieldset">
            <Field v-slot="{ field, errorMessage }" name="name">
              <div :class="['cr-form__field', { isError: errorMessage }]">
                <label class="cr-form__label" >
                  Контактное лицо
                  <span class="cr-form__asterisk">
                                        *
                                    </span>
                </label>
                <span v-if="errorMessage"
                      class="cr-form__error-text">
                                   {{ errorMessage }}

                                </span>
                <input placeholder="Иванов" v-bind="field"
                       class="cr-form__input" type="text" v-model="formData.name" />
              </div>
            </Field>
            <Field name="phone" v-slot="{ field, errorMessage, meta }">
            <div :class="['cr-form__field', { isError: errorMessage }]">
              <label class="cr-form__label" for="phone">
                Телефон
                <span class="cr-form__asterisk">
                                        *
                                    </span>
              </label>
              <span v-if="errorMessage"
                    class="cr-form__error-text">
                                   {{ errorMessage }}

                                </span>
                <MaskInput
                    v-bind="field"
                    :class="['cr-form__input']"
                    mask="+7 (###) ###-##-##"
                    placeholder="+7 ( _ _ _ ) _ _ _-_ _-_ _"
                    v-model="formData.phone"
                />
            </div>
            </Field>
            <Field v-slot="{ field, errorMessage }" name="email" mode="onBlur">
              <div :class="['cr-form__field', { isError: meta.touched && errorMessage }]">
                <label class="cr-form__label" >
                  E-mail
                  <span class="cr-form__asterisk">
                                        *
                                    </span>
                </label>
                <span v-if="meta.touched && errorMessage"
                      class="cr-form__error-text">
                                   {{ errorMessage }}

                                </span>
                <input placeholder="mail@mail.ru" v-bind="field"
                       class="cr-form__input" type="text" v-model="formData.email" />
              </div>
            </Field>
            <Field v-slot="{ field, errorMessage }" name="city">
              <div :class="['cr-form__field', { isError: errorMessage }]">
                <label class="cr-form__label" >
                  Город
                  <span class="cr-form__asterisk">
                                        *
                                    </span>
                </label>
                <span v-if="errorMessage"
                      class="cr-form__error-text">
                                   {{ errorMessage }}

                                </span>
                <input placeholder="Москва" v-bind="field"
                       class="cr-form__input" type="text" v-model="formData.city" />
              </div>
            </Field>
            <Field v-slot="{ field, errorMessage }" name="bar">
            <div :class="['cr-form__field', { isError: errorMessage }]">
              <label class="cr-form__label" for="place">
                Заведение
                <span class="cr-form__asterisk">
                                        *
                                    </span>
              </label>
              <span v-if="errorMessage"
                    class="cr-form__error-text">
                                   {{ errorMessage }}

                                </span>
              <input placeholder="Иванов" v-bind="field"
                     class="cr-form__input" type="text" v-model="formData.bar" />
            </div>
            </Field>
            <Field v-slot="{ field, errorMessage }" name="inn">
              <div :class="['cr-form__field', { isError: errorMessage }]">
                <label class="cr-form__label" >
                  ИНН
                  <span class="cr-form__asterisk">
                                        *
                                    </span>
                </label>
                <span v-if="errorMessage"
                      class="cr-form__error-text">
                                   {{ errorMessage }}

                                </span>
                <input placeholder="646456456" v-bind="field"
                       class="cr-form__input" type="text" v-model="formData.inn" />
              </div>
            </Field>
            <div class="cr-form__field">
              <label class="cr-form__label" for="comment">
                Комментарий
              </label>
              <textarea class="cr-form__textarea" name="comment" v-model="formData.comment" rows="3" placeholder="Если вы уже являетесь нашим клиентом, укажите ваши юр. наименование, менеджера, ИНН и другие данные для создания учетной записи"></textarea>
            </div>
          </fieldset>
          <div v-if="serverError" class="cr-detail-card__message cr-message cr-message--error" v-html="serverError"></div>
        </div>
        <div v-if="mainLoaded" class="cr-registration__section">
          <Menu></Menu>
        </div>
        <div class="cr-registration__section">
          <fieldset class="cr-form__fieldset">
            <div class="cr-form__field">
              <input class="cr-form__checkbox cr-form__checkbox--simple" type="checkbox" v-model="formData.subscribe" id="agreement">
              <label class="cr-form__label" for="agreement">
                Получать новости на e-mail
              </label>
            </div>
            <Field v-slot="{ field, errorMessage }" name="agreement">
            <div class="cr-form__field">
              <span v-if="errorMessage"
                    class="cr-form__error-text">
                                   {{ errorMessage }}

                                </span>
              <input class="cr-form__checkbox cr-form__checkbox--simple" type="checkbox" v-bind="field" v-model="formData.agreement" id="agreement1">
              <label class="cr-form__label" for="agreement1">
                Я прочитал и согласен с условиями <router-link to="/page/policy/">Политики конфиденциальности</router-link>
              </label>
            </div>
            </Field>
          </fieldset>
          <div class="cr-form__action">
            <button class="cr-button" type="submit">
                                <span class="cr-button__text">
                                    Отправить
                                </span>
            </button>
          </div>
        </div>
      </form>
      </Form>
    </div>
  </div>




</template>

<script>
import { MaskInput } from 'vue-3-mask';
import scrollToError from "@/mixin/scrollToError.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import axios from "axios";
import { Form, Field} from 'vee-validate';
import * as yup from 'yup';
import Menu from "@/views/components/Menu.vue";


export default {
  data: () => ({
    isSubmitting: null,
    serverError: null,
    formData: {
      name: '',
      phone: '',
      email: '',
      city: '',
      bar: '',
      inn: '',
      comment: '',
      subscribe: '',
      agreement: ''
    }
  }),
  mixins: [scrollToError],
  components: {Menu, Form, Field, MaskInput},
  setup() {
    const schema = yup.object().shape({
      name: yup.string()
          .required('Контактное лицо обязательно для заполнения')
          .min(2, 'Контактное лицо должно содержать минимум 2 символа'),
      bar: yup.string()
          .required('Заведение обязателен для заполнения'),
      phone: yup.string()
          .required('Телефон обязательна для заполнения'),
      email: yup.string()
          .required('Email обязателен для заполнения')
          .email('Введите корректный email адрес')
          .max(255, 'Email не должен превышать 255 символов'),
      city: yup.string()
          .required('Город обязателен для заполнения'),
      inn: yup.string()
          .required('ИНН обязателен для заполнения'),
      agreement: yup.boolean()
          .oneOf([true], 'Согласие обязательно для заполнения')
          .required('Согласие обязательно для заполнения')

    });

    const validateMode = {
      validateOnBlur: true,    // валидация при потере фокуса
      validateOnChange: false, // отключаем валидацию при каждом изменении
      validateOnInput: false,  // отключаем валидацию при вводе
      validateOnModelUpdate: false // отключаем валидацию при обновлении модели
    };

    return {
      schema,
      validateMode
    }

  },
  async created() {

  },
  computed: {

  },

  methods: {
    handleInvalidSubmit() {
      const firstError = document.querySelector('.isError');
      if (firstError) {
        firstError.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    async onSubmit(values
    ) {
      if (this.isSubmitting === true)
        return;
      this.isSubmitting = true;
        this.serverError = null;

      const formDataToSubmit = {
        ...this.formData,
      };

      try {
        const response = await axios.post('/api/user/register/', formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = 'Ошибка сервера.';
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }


          await this.$router.push({
            name: 'registration_success',
          });


      } catch (error) {
        this.serverError = error;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },

  }
}
</script>
